import { FAB as RNFAB, type FABProps as RNFABProps } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";

export type FABProps = RNFABProps;

export const FAB = ({ uppercase, style, ...props }: FABProps) => {
	const theme = useAppTheme();

	const isUpperCase =
		uppercase ??
		theme.componentOverrides?.button?.labelStyle?.textTransform === "uppercase";
	const overriddenStyle = theme.componentOverrides?.fab?.style;

	return (
		<RNFAB
			uppercase={isUpperCase}
			mode={theme.componentOverrides?.fab?.mode}
			{...props}
			style={[overriddenStyle, style]}
		/>
	);
};

FAB.Group = RNFAB.Group;
